<template>
    <div class="m_container">
        <el-form
            ref="rForm"
            :model="rForm"
            :rules="rRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
        >
            <div class="c-flex-ajcenter title_box">
                <h3 class="title">{{ $t('login.register') }}</h3>
                <LangSelect class="lang" />
            </div>
            <el-form-item prop="mobile">
                <el-input
                    v-model="rForm.mobile"
                    name="username"
                    type="text"
                    auto-complete="on"
                    :placeholder="$t('login.mobile')"
                    clearable
                    @input="bindKeyMobile"
                >
                    <i slot="prefix" class="el-icon el-icon-mobile-phone" />
                </el-input>
            </el-form-item>

            <el-form-item prop="password">
                <el-input
                    v-model="rForm.password"
                    :type="pwdType"
                    name="password"
                    auto-complete="off"
                    :placeholder="$t('login.password')"
                    clearable
                    @keyup.enter.native="submit"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item style="display:none;" />

            <el-form-item prop="password_confirmation">
                <el-input
                    v-model="rForm.password_confirmation"
                    :type="pwdType"
                    name="password_confirmation"
                    auto-complete="off"
                    clearable
                    :placeholder="$t('login.confirmPwd')"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>

            </el-form-item>

            <el-form-item prop="code">
                <div class="form-item">
                    <el-input
                        v-model="rForm.code"
                        name="code"
                        auto-complete="off"
                        :placeholder="$t('login.verificationCode')"
                        clearable
                        style="width: 60%;"
                    />
                    <el-button size="small" type="primary" :class="{'disabledBtn':codeBtn}" @click="getCode">{{ codeName }}</el-button>
                </div>
            </el-form-item>

            <el-form-item>
                <el-button
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width:100%;"
                    @click.native.prevent="submit"
                >{{ $t('login.register') }}</el-button>
            </el-form-item>
        </el-form>

        <div class="textWrap">
            <p class="register" @click="hancleChangeType('login')">{{ $t('login.loginIn') }}</p>
            <!-- <p>|</p>
            <p class="register" @click="hancleChangeType('password')">修改密码</p> -->
            <p>|</p>
            <p class="register" @click="hancleChangeType('reset')">{{ $t('login.reset') }}</p>
        </div>
    </div>
</template>

<script>
import LangSelect from '@/components/LangSelect'
import mix_auth from './mix_auth'
const defaultSettings = require('../../../settings')

export default {
    name: 'Register',
    components: { LangSelect },
    mixins: [mix_auth],
    data() {
        return {
            pageTitle: defaultSettings.title,
            rForm: {
                mobile: '',
                password: '',
                password_confirmation: '',
                code: ''
            }
        }
    },
    methods: {
        submit() {
            this.$refs['rForm'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.rForm)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.m_container {
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  background: #f5f5f5;

  .el-form{
    padding: 0;
    margin: 0 20px;

    .el-form-item{
      padding-left: 0;
    }

    .el-icon{
      display: inline-block;
      margin-top: 12px;
      margin-right: 8px;
      font-size: 16px;
    }

    .el-icon-view-actived{
      color: var(--color)
    }

    .form-item{
      display: flex;
      justify-content: space-between;
      align-items: center;

      .disabledBtn{
        background: #ccc;
        border-color: #ccc;
      }
    }
  }

    .title_box{
        padding: 50px 0;
        margin: 0 auto;

        .lang{
            transform:translate(10px,10px);
        }
    }

  .textWrap{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;

    .register{
      color: var(--color);
      font-weight: bold;
    }

    p{
      padding: 0 10px;
    }
  }
}
</style>
